import type {LightboxPress} from './lightbox.types';

export function isBackgroundClick({pressTarget, clickTarget, isBackground}: LightboxPress): boolean {
  if (!isBackground(clickTarget)) {
    return false;
  }

  return !pressTarget || isBackground(pressTarget);
}
